export default class QuizPageChecker {
  config = {
    bodyClass: "quiz-page",
  };

  constructor(config = {}) {
    this.config = { ...this.config, ...config };
    this.checkQuizPage();
  }

  checkQuizPage() {
    const body = document.body;
    const hasQuizPageClass = body.classList.contains(this.config.bodyClass);
    
    if (hasQuizPageClass) {
      setTimeout(() => {
        body.classList.add('quiz-others-fade-in');
      }, 1500);
    }
    
    return hasQuizPageClass;
  }
}
